import { render, staticRenderFns } from "./activityButton.vue?vue&type=template&id=467b844e"
import script from "./activityButton.vue?vue&type=script&lang=js"
export * from "./activityButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports